import { MutationHookOptions, TypedDocumentNode, gql } from "@apollo/client";

import {
  ReopenAlertMutation,
  ReopenAlertMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { alertFragment } from "src/graphql/anti-fraud/fragments/AlertFragment";
import { getAlertById } from "src/graphql/anti-fraud/queries/alerts/GetAlertByIdQuery.ts";
import { usePerformMutation } from "src/graphql/utils";

const reopenAlertMutation = gql`
  mutation reopenAlert($id: ID!) {
    reopenAlert(id: $id) {
      ...AlertFragment
    }
  }

  ${alertFragment}
` as TypedDocumentNode<ReopenAlertMutation, ReopenAlertMutationVariables>;

export const useReopenAlertMutation = ({
  mutationOption,
  onSuccess,
}: {
  onSuccess?: () => void;
  mutationOption?: MutationHookOptions<ReopenAlertMutation, ReopenAlertMutationVariables>;
} = {}) => {
  return usePerformMutation(reopenAlertMutation, {
    onSuccess,
    mutationOption: {
      refetchQueries: [getAlertById],
      ...mutationOption,
    },
  });
};
